__turbopack_context__.v({
  "actions": "RestrictionModal-module-scss-module__YRWola__actions",
  "backdrop": "RestrictionModal-module-scss-module__YRWola__backdrop",
  "button": "RestrictionModal-module-scss-module__YRWola__button",
  "buttonGhost": "RestrictionModal-module-scss-module__YRWola__buttonGhost",
  "buttonPrimary": "RestrictionModal-module-scss-module__YRWola__buttonPrimary",
  "description": "RestrictionModal-module-scss-module__YRWola__description",
  "enter": "RestrictionModal-module-scss-module__YRWola__enter",
  "exit": "RestrictionModal-module-scss-module__YRWola__exit",
  "fade-in": "RestrictionModal-module-scss-module__YRWola__fade-in",
  "fade-out": "RestrictionModal-module-scss-module__YRWola__fade-out",
  "fade-out-80": "RestrictionModal-module-scss-module__YRWola__fade-out-80",
  "panel": "RestrictionModal-module-scss-module__YRWola__panel",
  "slide-in-from-bottom": "RestrictionModal-module-scss-module__YRWola__slide-in-from-bottom",
  "slide-in-from-left": "RestrictionModal-module-scss-module__YRWola__slide-in-from-left",
  "slide-in-from-right": "RestrictionModal-module-scss-module__YRWola__slide-in-from-right",
  "slide-in-from-top": "RestrictionModal-module-scss-module__YRWola__slide-in-from-top",
  "slide-out-to-bottom": "RestrictionModal-module-scss-module__YRWola__slide-out-to-bottom",
  "slide-out-to-left": "RestrictionModal-module-scss-module__YRWola__slide-out-to-left",
  "slide-out-to-right": "RestrictionModal-module-scss-module__YRWola__slide-out-to-right",
  "slide-out-to-top": "RestrictionModal-module-scss-module__YRWola__slide-out-to-top",
  "textBlock": "RestrictionModal-module-scss-module__YRWola__textBlock",
  "title": "RestrictionModal-module-scss-module__YRWola__title",
  "zoom-in": "RestrictionModal-module-scss-module__YRWola__zoom-in",
  "zoom-out": "RestrictionModal-module-scss-module__YRWola__zoom-out",
});
